/**
 * Rolling local history of the last N run scores. Used for the
 * end-of-run sparkline. Ranked + daily + practice all contribute so
 * the line shows "how I'm playing lately" regardless of mode.
 */

const KEY = "aether.history";
const MAX = 10;

export function recordRun(score: number) {
  try {
    const list = load();
    list.push(score);
    while (list.length > MAX) list.shift();
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* quota */
  }
}

export function load(): number[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((n) => typeof n === "number") : [];
  } catch {
    return [];
  }
}

/**
 * Render a sparkline as an SVG string. Caller injects it via innerHTML.
 * Width/height kept small so it slots into the run-end card without
 * stealing vertical space.
 */
export function renderSparkline(values: number[], w = 220, h = 36): string {
  if (values.length < 2) {
    return `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" aria-hidden="true"></svg>`;
  }
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;
  const stepX = w / (values.length - 1);
  const points = values
    .map((v, i) => {
      const x = i * stepX;
      const y = h - ((v - min) / range) * (h - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  const last = values[values.length - 1];
  const lastX = (values.length - 1) * stepX;
  const lastY = h - ((last - min) / range) * (h - 4) - 2;
  return `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" aria-hidden="true">
    <polyline fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" points="${points}" opacity="0.85" />
    <circle cx="${lastX.toFixed(1)}" cy="${lastY.toFixed(1)}" r="2.5" fill="currentColor" />
  </svg>`;
}
